import { APIGatewayService } from '@core/gateway/APIGateway.service';
import CustomStore from "devextreme/data/custom_store";
import { AppInjector } from '@core/injector/injector.module';
import { BaseDataStoreAbstract } from './BaseDataStoreAbstract';
import { Observable } from 'rxjs';
import { DataLoadOptions } from './DataLoadOptions';


export class BaseDataStoreReadOnly extends BaseDataStoreAbstract
{
    private api: APIGatewayService;

    constructor(
        private ControllerName?: string,
        private ActionName?: string,
        private QueryParams?: any,
        private customLoadAction?: (options?: DataLoadOptions) => Observable<any>,
        private customGetAction?: (Value: any) => Observable<any>,
        // @ts-ignore
        private OnLoadedHandler?: (Data: any[]) => void,
        private IsRaw: boolean = true,
        // @ts-ignore
        private KeyFieldName: any = "EntryID")
    {
        //Base
        super();

        //Cannot inject in constructor since we create the class manually
        this.api = AppInjector.get(APIGatewayService);

        //Create custom store. Separated because of ByKey callback, does not work if put together conditionally
        if (this.IsRaw)
        {
            this.m_store = new CustomStore({
                key: KeyFieldName,
                loadMode: "raw",
                load: () => this.ImplementLoad(undefined),
                onLoaded: (data) => OnLoadedHandler ? OnLoadedHandler(data) : {}
            });

        }
        else
        {
            this.m_store = new CustomStore({
                key: KeyFieldName,
                loadMode: "processed",
                load: (loadOptions) => this.ImplementLoad(loadOptions),
                byKey: (Value) => this.ImplementByKey(Value),
                onLoaded: (data) => OnLoadedHandler ? OnLoadedHandler(data) : {}
            });
        }
        

    }

    //Perform the actual load
    private ImplementLoad(loadOptions): Promise<any>
    {
        //Prepare options object
        var options = new DataLoadOptions(loadOptions);

        if (this.customLoadAction == undefined)
        {
            return this.ShapeResponse(this.api.ExecuteGetAction(this.ControllerName, this.ActionName, { ...this.QueryParams, ...options.GetLoadOptions() }));
        }
        else
        {
            return this.ShapeResponse(this.customLoadAction(options));
        }
    }

    //Get data by key
    private ImplementByKey(Value: any): Promise<any>
    {
        return this.ShapeResponse(this.customGetAction(Value));
    }
}
